/**
 * Immediate on/off setting. Applies instantly — no Save button.
 * Spec: assets/handoffs/design_system_export/specs/Toggle.json
 *
 * @param {'sm'|'md'=md} size
 * @param {boolean=false} checked
 * @param {boolean=false} disabled
 * @param {function=} onChange - (nextChecked: boolean) => void
 * @param {string} label - required, becomes aria-label (the setting's name, not "on"/"off")
 */
import React, { forwardRef } from "react";
import classNames from "classnames";
import styles from "./Toggle.module.scss";

const Toggle = forwardRef(
  ({ size = "md", checked = false, disabled = false, onChange, label, className, ...rest }, ref) => {
    const handleClick = () => {
      if (disabled) return;
      onChange?.(!checked);
    };

    return (
      <button
        ref={ref}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled}
        onClick={handleClick}
        className={classNames(
          styles.root,
          styles[`root--${size}`],
          { [styles["is-on"]]: checked },
          className
        )}
        {...rest}
      >
        <span className={styles.knob} />
      </button>
    );
  }
);

Toggle.displayName = "Toggle";

export default Toggle;
